import { render, staticRenderFns } from "./actionDialog.vue?vue&type=template&id=5bc4f5cf"
import script from "./actionDialog.vue?vue&type=script&lang=js"
export * from "./actionDialog.vue?vue&type=script&lang=js"
import style0 from "./actionDialog.vue?vue&type=style&index=0&id=5bc4f5cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports